<!-- 新投放数据看板 -->
<template>
	<div class="page-big-box" key="">
		<div id="" :style="{'width':table_scroll_width + 'px',}">
			
		
		<div :style="{'width':body_width - 40 + 'px',}" style="position: sticky;left: 20px;z-index: 5;background-color: #fff;padding: 20px;margin-bottom: 15px;">
			<!-- 标题 -->
			<div class="page-title">新投放数据看板</div>
			
			<!-- 筛选条件 -->
			<div style="margin: 10px 0 0;">
				<div class="class-title">筛选条件</div>
				
				<a-row type="flex" justify="start">
				    <a-col :span="22">
					<a-row type="flex" justify="start" style="align-items: center;">
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">投放日期</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-range-picker style="width:100%" @change="onChangeDate" :allowClear="false"
									:locale="locale" 
									:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
								</a-col>
							</a-row>
						</a-col>
						
						<a-col v-if="search_control_a" :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">渠道内容</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									
									<a-select
										mode="multiple"
										style="width: 100%"
										placeholder="请选择渠道内容"
										@change="handleChangeQ"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										allowClear
									  >
										<template v-if="filterData.hasOwnProperty('content_channel') && Object.keys(filterData.content_channel).length > 0">
											<a-select-option v-for="(value,key) in filterData.content_channel.list" :key="key" :value="key">
											  {{value}}
											</a-select-option>
										</template>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">H5书城渠道</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-select
										mode="multiple"
										style="width: 100%;"
										placeholder="请选择H5书城渠道"
										@change="handleChangeF"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										:value="r_channel_id"
										allowClear
									  >
										<a-select-option v-for="(value,key) in filterData.gzh_channel.list" :key="key" :value="key">
										  {{value}}
										</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">公众号</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<searchLinkSelect page_type="effectB" ref="getGzhLink" @handleChangeSelect="handleChangeGzh"></searchLinkSelect>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">快应用渠道</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<a-select
									style="width: 100%"
									placeholder="请选择快应用渠道"
									@change="handleChangeY"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
									<a-select-option v-for="(value,key) in filterData.qk_channel_new.list" :key="key" :value="key">
									  {{value}}
									</a-select-option>
								</a-select>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">快应用推广链接</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<searchLinkSelect no_found_text="请先选择快应用渠道" page_type="effectB" ref="getKyyLink" @handleChangeSelect="handleChangeS"></searchLinkSelect>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">小程序渠道</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<a-select
									mode="multiple"
									style="width: 100%"
									placeholder="请选择小程序渠道"
									@change="handleChangeV"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
									<!-- <a-select-option v-for="(value,key) in filterData.vd_channel.list" :key="key" :value="key">
									  {{value}}
									</a-select-option> -->
									<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
									  {{value}}
									</a-select-option>
								</a-select>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">小程序</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<xcxSearchSelect ref="getXcxSelect" :s_width="'100%'" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">小程序推广链接</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<searchLinkSelect page_type="effectB" ref="videLinkeSelect" @handleChangeSelect="handleChangeX"></searchLinkSelect>
								</a-col>
							</a-row>
						</a-col>
						
						<!-- <a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">小说小程序渠道</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<a-select
									mode="multiple"
									style="width: 100%"
									placeholder="请选择小说小程序渠道"
									@change="handleChangeXS"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
									<a-select-option v-for="(value,key) in filterData.mp_book_channel.list" :key="key" :value="key">
									  {{value}}
									</a-select-option>
								</a-select>
							</a-col>
						  </a-row>
						</a-col> -->
						
						<!-- <a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">小说小程序推广链接</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									
									<searchLinkSelect page_type="effectB" ref="xsXcxSelect" @handleChangeSelect="handleChangeXsLink"></searchLinkSelect>
								</a-col>
							</a-row>
						</a-col> -->
						
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">投放作品</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<putBookSelect page_type="effectB" style="width: 100%;" ref="getPutBook" @handleChangeSelect="handleChangeB"></putBookSelect>
								</a-col>
							</a-row>
						</a-col>
						  
						<a-col v-if="search_control_b" :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">作品频道</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<a-select :value="r_book_type" style="width: 100%;"
								 @change="handleChangeC" 
								 :getPopupContainer="getsPopupContainer">
									<a-select-option  v-for="(item,index) in filterData.book_type.list" :key="index" :value="item.key">
										{{item.value}}
									</a-select-option>
									  
								</a-select>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
						  <a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="col-left-label">媒体平台</a-col>
							<a-col :span="col_content_span" class="padding-right-15">
								<a-select
								    mode="multiple"
								    style="width: 100%;"
								    placeholder="请选择媒体平台"
								    @change="handleChangeD"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
								    <a-select-option v-for="(item,index) in filterPlatform" :key="index" :value="item.id">
								      {{item.platform_name}}
								    </a-select-option>
								</a-select>
							</a-col>
						  </a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">媒体版位</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-select
										mode="multiple"
										style="width: 100%"
										placeholder="请选择媒体版位"
										@change="handleChangeE"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										allowClear
									  >
										<a-select-option v-for="(item,index) in filterData.media_id.list" :key="index" :value="item.key">
										  {{item.value}}
										</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
						
						<a-col v-if="Object.keys(filterData.op_id).length > 0" :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">投手</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-select
										mode="multiple"
										style="width: 100%"
										placeholder="请选择投手"
										@change="handleChangeA"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										allowClear
									  >
										<a-select-option v-for="(item,index) in filterData.op_id.list" :key="index" :value="item.key" >
										  {{item.value}}
										</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
						
						<a-col v-if="filterData.hasOwnProperty('group') && Object.keys(filterData.group).length > 0" :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">投放小组</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-select
										mode="multiple" 
										style="width: 100%;"
										placeholder="请选择投放小组"
										@change="handleChangeT"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										allowClear
										showSearch
									  >
										<a-select-option v-for="(item,index) in filterData.group.list" :key="item.id" :value="item.id">
										  {{item.group_name}}
										</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
						
						<a-col :span="6" class="margin-bottom-15">
							<a-row type="flex" align="middle">
								<a-col :span="col_left_span" class="col-left-label">数据录入状态</a-col>
								<a-col :span="col_content_span" class="padding-right-15">
									<a-select
										style="width: 100%;"
										placeholder="请选择数据录入状态"
										@change="handleChangeL"
										:filter-option="filterOption"
										:getPopupContainer="getsPopupContainer"
										allowClear
										showSearch
										:value="r_has_record"
									  >
										<template v-if="filterData.hasOwnProperty('has_record') && Object.keys(filterData.has_record).length > 0">
											<a-select-option v-for="(item,index) in filterData.has_record.list || []" :key="item.key" :value="item.key">
											  {{item.name}}
											</a-select-option>
										</template>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
					
					</a-col>
					<a-col :span="2" style="display: flex;flex-direction: column;align-items: center;">
						<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="margin-bottom-15">搜索</a-button>
						<a-button @click="exportButton" type="primary" icon="download" class="margin-bottom-15">导出</a-button>
					</a-col>
				</a-row>
			</div>
			<!-- 汇总条件 -->
			<div style="margin: 10px 0 0;">
				<div class="class-title">汇总条件</div>
				<div style="display: flex;align-items: center;flex-wrap: wrap;">
					<div v-for="(item,index) in collectHeadLabel" :key="index">
						<div v-if="item.label === '投放日期'" style="display: flex;align-items: center;margin-right: 15px;">
							<a-checkbox @change="handleChangeHZ($event,index)" :checked='item.checked_status'>
								投放日期
							</a-checkbox>
							<a-select default-value="day" style="width: 100px" @change="handleChangeH">
								  <a-select-option v-for="(item,index) in filterData.time_type.list" :key="index" :value="item.key">
									{{item.value}}
								  </a-select-option>
							</a-select>
						</div>
						
						<div v-else id="">
							<a-checkbox :checked='item.checked_status' @change="handleChangeHZ($event,index)" style="margin-right: 5px;">
								{{item.label}}
							</a-checkbox>
						</div>
						
					</div>

				</div>
			</div>
			<!-- 数据项 -->
			<div style="margin: 20px 0 0;">
				<div class="class-title">数据项</div>
				<div style="display: flex;align-items: center;flex-wrap: wrap;">
					<template v-for="(item,index) in tableThLabel">
					<a-checkbox v-if="item.show_control || isAuth" @change="onChangeSJ($event,index)" :checked="item.checked_status" style="margin-right: 5px;">
						{{item.label}}
					</a-checkbox>
					</template>
				</div>
			</div>
			
			<!-- <div style="margin-top: 20px;margin-bottom: 20px;">
				<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
				<a-button @click="exportButton" type="primary" icon="download">导出</a-button>
			</div> -->
		
			
		</div>
		</div>
		
		<div class="loading-box" v-show="search_button_loading">
			<a-spin size="large" />
		</div>
		
		<div style="background-color: #fff;padding-bottom: 30px;" :style="{'width': table_scroll_width + 'px','min-width':table_min_width + 'px'}">
			<!-- 表格内容 -->
			<TableShow id="table-show-box" @table-th-click="tableThClick" :rableTitle="rableTitle" :tableShowData="tableShowData" :tableTotalData="tableTotalData" :table_scroll_width="table_scroll_width" :date_type_control="date_type_control"></TableShow>
			
			<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
			<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;position: sticky;left: 20px;"
			:style="{'width': table_null_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			</div>
			
			<!-- 分页 -->
			<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
			:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
			@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
		</div>
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { putDataMenu,putDataPlatform,putDataGetChargeSumNew, putDataExport } from '@/request/api'
import TableShow from '@/components/putDataTable/TableShowB.vue'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
import putBookSelect from './components/putBookSelect.vue'
import searchLinkSelect from './components/searchLinkSelect.vue'
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
export default {
	name: 'summaryB_',
	components: {
		TableShow,moreSelect,putBookSelect,searchLinkSelect, xcxSearchSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2023-04-29',
			endTime: '2023-05-29',
			
			// 筛选条件部分
			filterData: {
				op_id:{},
				book_id:{},
				book_type:{},
				media_id:{},
				channel_id:{},
				gzh_id:{},
				time_type:{},
				group: {},
				
				content_channel: {},
				gzh_channel: {},
				qk_channel_new: {},
				vd_channel: {},
				mp_book_channel: {},
				
				has_record: {}, // 数据录入状态
			}, // 筛选条件数组
			filterPlatform: [{}], // 筛选条件的-媒体平台
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1600, // 被表格撑开的实际内容宽度
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_op_id:[], // 搜索条件：投手id
			r_put_book: [], // 搜索条件：书籍
			r_book_type: 0, // 搜索条件：书籍类型，1=男频，2=女频，0是全部，全部的情况好像可以不发送
			r_platform_id: [], // 媒体平台
			r_media_id: [], // 媒体版位
			r_channel_id: [], //  书城
			r_gzh_id: [], // 公众号
			r_group_id: undefined, // 投放小组
			r_date_type: "day", // 默认是天
			r_has_record: undefined, // 数据录入状态
			r_appid: undefined, // 选择小程序
			
			// 汇总条件
			collectHeadLabel: [
				{label:"投放日期", checked_status: true, type:"date_key",},
				
				{label:"渠道内容", checked_status: false, type:"content_type",},
				{label:"渠道", checked_status: false, type:"channel_id",},
				{label:"公众号/推广链接", checked_status: false, type:"gzh_id",},
				
				{label:"投放作品", checked_status: false, type:"put_book",},
				{label:"作品频道", checked_status: false, type:"put_book.type",},
				
				{label:"媒体平台", checked_status: false, type:"put_media.type",},
				{label:"媒体版位", checked_status: false, type:"media_id",},
				
				{label:"投手", checked_status: false, type:"op_id",},
				{label:"投放小组", checked_status: false, type:"group_id",},
				
				{label:"小程序", checked_status: false, type:"appid",},
			], // 汇总条件
			// 数据项
			tableThLabel: [
				{label:"投放金额", checked_status: true, type:"put_money",show_control: true,},
				{label:"净投放金额", checked_status: true, type:"used_money",show_control: true,},
				
				{label:"总充值金额", checked_status: false, type:"total_charge_money",show_control: false,},
				{label:"总分成金额",checked_status: false,type:"left_money",show_control: false,},
				{label:"总ROI",checked_status: false,type:"roi",show_control: false,},
				{label:"总付费人数",checked_status: false,type:"pay_user_num",show_control: false,},
				{label:"总付费成本",checked_status: false,type:"pay_cost",show_control: false,},
				
				{label:"粉丝数",checked_status: true,type:"sub_num",show_control: true,},
				{label:"粉丝成本",checked_status: true,type:"sub_num_price",show_control: true,},
				
				{label:"当天充值金额",checked_status: true,type:"today_charge_money",show_control: true,},
				{label:"当天分成金额",checked_status: true,type:"today_left_money",show_control: true,},
				
				{label:"当天付费人数",checked_status: true,type:"today_pay_user_num",show_control: true,},
				{label:"当天付费成本",checked_status: true,type:"today_pay_user_num_cost",show_control: true,},
				{label:"首日ROI",checked_status: true,type:"today_roi",show_control: true,},
				{label:"DAY2-分成金额",checked_status: true,type:"recent_left_money_next_1",show_control: true,},
				{label:"DAY2-ROI",checked_status: true,type:"recent_left_money_roi_next_1",show_control: true,},
				{label:"近7日ROI",checked_status: false,type:"recent_left_money",show_control: false,},
				{label:"近7日分成roi",checked_status: false,type:"seven_roi",show_control: false,},
				{label:"近7日分成明细",checked_status: false,type:"seven_left_money",show_control: false,},
			], // 数据项的选择，对应表头显示的内容
			tableShowData: [], // 表格用来展示的数据
			tableTotalData: [], // 总计，表格第一行
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"投放日期",width:90, sort_status:0,type:"date_key",show_control: true, text_right: false, sort_control:true, }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道内容",width:90, sort_status:0,type:"content_type",show_control: false, text_right: false, sort_control:false, },
				// {title:"渠道",width:90, sort_status:0,type:"channel_id",show_control: false, text_right: false, sort_control:false, },
				{title:"渠道",width:100, sort_status:0,type:"channel_name",show_control: false, text_right: false, sort_control:false, },
				{title:"公众号/推广链接",width:150, sort_status:0,type:"gzh_name",show_control: false, text_right: false, sort_control:false, },
				{title:"投放作品",width:100, sort_status:0,type:"book_name",show_control: false, text_right: false, sort_control:false, },
				// {title:"作品类型",width:90, sort_status:0,type:"book_type",show_control: false, text_right: false, sort_control:false, },
				{title:"作品频道",width:90, sort_status:0,type:"book_type",show_control: false, text_right: false, sort_control:false, },
				{title:"媒体平台",width:90, sort_status:0,type:"platform_name",show_control: false, text_right: false, sort_control:false, },
				{title:"媒体版位",width:90, sort_status:0,type:"media_name",show_control: false, text_right: false, sort_control:false, },
				{title:"投手",width:90, sort_status:0,type:"op_name",show_control: false, text_right: false, sort_control:false, },
				{title:"投放小组",width:120, sort_status:0,type:"group_name",show_control: false, text_right: false, sort_control:false, },
				{title:"小程序",width:90, sort_status:0,type:"applets_name",show_control: false, text_right: false, sort_control:false, },
				
				{title:"投放金额(元)",width:110, sort_status:0,type:"put_money",show_control: true, text_right: true, sort_control:true, },
				{title:"净投放金额(返点后)",width:150, sort_status:0,type:"used_money",show_control: true, text_right: true, sort_control:true, },
				
				{title:"总充值金额(元)",width:130, sort_status:0,type:"total_charge_money",show_control: false, text_right: true, sort_control:true, },
				{title:"总分成金额(元)",width:130, sort_status:0,type:"left_money",show_control: false, text_right: true, sort_control:true, },
				{title:"总ROI",width:90, sort_status:0,type:"roi",show_control: false, text_right: true, sort_control:true, },
				{title:"总付费人数",width:100, sort_status:0,type:"pay_user_num",show_control: false, text_right: true, sort_control:true, },
				{title:"总付费成本",width:100, sort_status:0,type:"pay_cost",show_control: false, text_right: true, sort_control:true, },
				
				{title:"粉丝数",width:90, sort_status:0,type:"sub_num",show_control: true, text_right: true, sort_control:true, },
				{title:"粉丝成本",width:90, sort_status:0,type:"sub_num_price",show_control: true, text_right: true, sort_control:true, },
				
				{title:"当天充值金额",width:120, sort_status:0,type:"today_charge_money",show_control: true, text_right: true, sort_control:true, },
				{title:"当天分成金额",width:120, sort_status:0,type:"today_left_money",show_control: true, text_right: true, sort_control:true, },
				
				{title:"当天付费人数",width:120, sort_status:0,type:"today_pay_user_num",show_control: true, text_right: true, sort_control:true, },
				{title:"当天付费成本(元)",width:135, sort_status:0,type:"today_pay_user_num_cost",show_control: true, text_right: true, sort_control:true, },
				{title:"首日ROI",width:90, sort_status:0,type:"today_roi",show_control: true, text_right: true, sort_control:true, },
				{title:"DAY2-分成金额",width:140, sort_status:0,type:"recent_left_money_next_1",show_control: true, text_right: true, sort_control:true, },
				{title:"DAY2-ROI",width:125, sort_status:0,type:"recent_left_money_roi_next_1",show_control: true, text_right: true, sort_control:true, },
				{title:"近7日ROI",width:100, sort_status:0,type:"recent_left_money",show_control: true, text_right: true, sort_control:true, },
				
				{title:"ROI_前7天",width:100, sort_status:0,type:"recent_left_money_roi_before_7",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前6天",width:100, sort_status:0,type:"recent_left_money_roi_before_6",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前5天",width:100, sort_status:0,type:"recent_left_money_roi_before_5",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前4天",width:100, sort_status:0,type:"recent_left_money_roi_before_4",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前3天",width:100, sort_status:0,type:"recent_left_money_roi_before_3",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前2天",width:100, sort_status:0,type:"recent_left_money_roi_before_2",show_control: true, text_right: true, sort_control:true, },
				{title:"ROI_前1天",width:100, sort_status:0,type:"recent_left_money_roi_before_1",show_control: true, text_right: true, sort_control:true, },
				{title:"分成金额_前7天",width:130, sort_status:0,type:"recent_left_money_before_7",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前6天",width:130, sort_status:0,type:"recent_left_money_before_6",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前5天",width:130, sort_status:0,type:"recent_left_money_before_5",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前4天",width:130, sort_status:0,type:"recent_left_money_before_4",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前3天",width:130, sort_status:0,type:"recent_left_money_before_3",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前2天",width:130, sort_status:0,type:"recent_left_money_before_2",show_control: false, text_right: true, sort_control:true, },
				{title:"分成金额_前1天",width:130, sort_status:0,type:"recent_left_money_before_1",show_control: false, text_right: true, sort_control:true, },
				
			],
			// 这个这得为数组，不能是字符串，因为是字符串的话，匹配不准
			zz_string:["date_key","op_name","book_name","book_type","platform_name","media_name","channel_name","gzh_name","group_name","put_money","used_money","total_charge_money","left_money","roi","today_roi","recent_left_money","sub_num","sub_num_price","pay_user_num","pay_cost","today_pay_user_num","today_pay_user_num_cost","recent_left_money_before_1","recent_left_money_before_2","recent_left_money_before_3","recent_left_money_before_4","recent_left_money_before_5","recent_left_money_before_6","recent_left_money_before_7","recent_left_money_roi_before_1","recent_left_money_roi_before_2","recent_left_money_roi_before_3","recent_left_money_roi_before_4","recent_left_money_roi_before_5","recent_left_money_roi_before_6","recent_left_money_roi_before_7"], // 用于判断/过滤
			date_type_control: 'day', // 日期的控制，是展示日、月还是周
			r_page: 1, // 页数
			r_limit: 100, // 每页多少条
			table_total: 0, // 表格内容总数
			table_min_width: 1600, // 最小宽度
			
			role_control: [], // 用户权限控制
			
			col_left_span: 7,
			col_content_span: 17, 
			
			r_content_type: undefined, // 渠道内容
			r_qk_channel_id: [], // 快应用书城id
			r_vd_qd: [], // 短剧渠道
			r_qk_url: [], // 选择的快应用推广链接
			r_vd_channel: [], // 短剧推广链接
			r_xs_xcx_channel: [], // 小说小程序渠道
			r_xs_xcx_link: [], // 小说小程序渠道推广链接
			
			search_control_a: true, // 渠道内容
			search_control_b: true, // 作品频道
			
			px_sort: null, // 排序方式，正序或倒序
			px_order: null, // 排序字段
			
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
		};
	},
	computed: {
		// 是否有全部数据权限
		isAuth () {
			return this.role_control.includes(24)
		},
	},
	mounted(){
		let that = this
		
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background:rgb(240, 242, 245)')
		
		this.search_button_loading = true
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		that.table_scroll_width = document.body.scrollWidth - 30 // 获取表格内容的宽度
		that.table_min_width = document.body.clientWidth - 60
		console.log("that.table_min_width",that.table_min_width);
		
		// 给表格数据备一份原始宽度数据，避免自适应后，原始宽度数据没了
		that.rableTitle.forEach(res=>{
			res.s_width = res.width
		})
		
		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()
		
		putDataMenu().then((res)=>{
			// console.log("putDataMenu",res.data.data.filter)
			that.filterData = res.data.data.filter
			
			let f_select = res.data.data.filter
			that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
			
			try{ // 正常执行的代码
				console.log("正常执行的代码");
				// that.$refs.getGzhSelect.getSelectData(that.filterData.gzh_id.list || [])
				
				that.$refs.getPutBook.getSelectData(that.filterData.book_id.list || [])
			}catch(err){ // 如果出错，抛出错误
				// 处理错误
				console.log("处理错误",err);
				
				// that.$refs.getGzhSelect.getSelectData(that.filterData.gzh_id.list || [])
				
				that.$refs.getPutBook.getSelectData(that.filterData.book_id.list || [])
			}
			
			console.log("has_record",Object.keys(that.filterData.has_record))
			// 如果 数据录入状态 项，有下拉内容，则默认值要改为 已录入
			if(that.filterData.hasOwnProperty('has_record') && Object.keys(that.filterData.has_record).length > 0){ 
				that.r_has_record = 1
			}
			
			that.$nextTick(()=>{
				try{
					that.$refs.getGzhLink.getSelectData('',1)
				}catch(e){
					
				}
				try{
					that.$refs.videLinkeSelect.getSelectData('', 3)
				}catch(e){
					
				}
				try{
					that.$refs.xsXcxSelect.getSelectData('', 4)
				}catch(e){
					
				}
				// that.$refs.getKyyLink.getSelectData('',2)
			})
			
			// 获取29天前日期
			that.startTime = this.$getBeforeDay(29)
			// that.startTime = this.$getThisDay()
			// 获取当前日期
			that.endTime = this.$getThisDay()
			
			// 获取角色权限
			that.role_control = JSON.parse(localStorage.getItem("role_limits"))
			if(that.role_control.includes(1) || that.role_control.includes(3) || that.role_control.includes(24)){
				that.tableThLabel.forEach((res)=>{
					res.show_control = true
					if(res.type == 'recent_left_money'){
						res.checked_status = false
					}
					else if(res.type == 'seven_roi'){
						res.checked_status = false
					}
					else if(res.type == 'seven_left_money'){
						res.checked_status = false
					}
					else {
						res.checked_status = true
					}
				})
			}
			
			// 搜索
			that.searchButton()
		})
		.catch(err=>{
			// this.search_button_loading = false
		})
		
		putDataPlatform({limit:1000,page:1}).then((res)=>{
			console.log("获取投放数据看板-筛选条件-媒体平台",res.data.data.data)
			that.filterPlatform = res.data.data.data || []
			// this.search_button_loading = false
		})
		.catch(err=>{
			// this.search_button_loading = false
		})
		
		
	},
	// 销毁节点之前就删除属性
	beforeDestroy() {
	    document.querySelector('body').removeAttribute('style')
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 投手
		handleChangeA(value) {
			console.log(value)
			this.r_op_id = value // 记录选择的人的id
		},
		
		// 投放作品
		handleChangeB(value) {
			this.r_put_book = value
		},
		
		// 作品类型
		handleChangeC(value) {
			this.r_book_type = value
		},
		
		// 媒体平台
		handleChangeD(value) {
			this.r_platform_id = value
		},
		
		// 媒体版位
		handleChangeE(value) {
			this.r_media_id = value
		},
		
		// 书城
		handleChangeF(value) {
			this.r_channel_id = value
			
			this.$refs.getGzhLink.getSelectData(value,1)
		},
		
		// 公众号
		handleChangeGzh(value) {
			this.r_gzh_id = value
		},
		// 投手小组
		handleChangeT(value){
			this.r_group_id = value
		},
		// 汇总条件
		handleChangeHZ(e,index){
			this.collectHeadLabel[index].checked_status = e.target.checked
			// console.log(`checked = ${e.target.checked}`);
		},
		// 汇总条件-投放日期
		onChangeHA(e) {
		  // console.log(`checked = ${e.target.checked}`);
		},
		handleChangeH(value) { // 这个有用到，不要删
		    // console.log(`selected ${value}`);
			this.r_date_type = value
		},
		// 渠道内容
		handleChangeQ(e){
			this.r_content_type = e
		},
		// 快应用书城
		handleChangeY(e){
			let that = this
			this.r_qk_channel_id = e
			this.r_qk_url = []
			this.$refs.getKyyLink.getSelectData(e,2)
		},
		// 快应用推广链接
		handleChangeS(e){
			// console.log("快应用推广链接",e);
			this.r_qk_url = e
		},
		// 短剧推广链接
		handleChangeX(e){
			this.r_vd_channel = e
		},
		// 短剧渠道
		handleChangeV(e){
			let that = this
			that.r_vd_qd = e
			this.$refs.videLinkeSelect.getSelectData(e, 3)
			// 获取小程序下拉
			this.$refs.getXcxSelect.getSelectData(e)
		},
		// 小说小程序渠道
		handleChangeXS(e){
			this.r_xs_xcx_channel = e
			this.$refs.xsXcxSelect.getSelectData(e, 4)
		},
		handleChangeXsLink(e){
			this.r_xs_xcx_link = e
		},
		// 数据项————————
		onChangeSJ(e,index){
			this.tableThLabel[index].checked_status = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
		},
		handleChangeL(e){ // 数据录入
			// console.log("数据录入",e)
			this.r_has_record = e
		},
		
		// 选择小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		
		// 搜索按钮。class_是指排序方式desc或asc。type_是指要排序的表头。button_type表示按钮的操作类型，比如分页的搜索
		searchButton(class__,type__,button_type){
			let that = this
			
			let class_ = that.px_sort
			let type_ = that.px_order
			
			// console.log()
			if(that.collectHeadLabel.findIndex(target=>target.checked_status === true) === -1){
				this.$warning({
					title: '警告',
					content: '请至少选择一个汇总条件',
				});
			}
			else if(that.tableThLabel.findIndex(target=>target.checked_status === true) === -1){
				this.$warning({
					title: '警告',
					content: '请至少选择一个数据项',
				});
			}
			else if(!that.startTime || !that.endTime){
				this.$warning({
					title: '警告',
					content: '请选择日期范围',
				});
			}
			else {
				
			if(button_type != '分页'){
				that.r_page = 1
			}
			
			this.search_button_loading = true
			
			let r_data = {
				start_time : that.startTime.replace(/-/g, ''),
				end_time : that.endTime.replace(/-/g, ''),
				put_book: that.r_put_book,
				// book_type: that.r_book_type,
				platform_id: that.r_platform_id,
				media_id: that.r_media_id,
				channel_id: that.r_channel_id,
				gzh_id: that.r_gzh_id,
				group_id: that.r_group_id,
				
				page: that.r_page,
				limit: that.r_limit,
				
				content_type: that.r_content_type, // 渠道内容
				
				has_record: that.r_has_record, // 数据录入状态
				
				appid: that.r_appid,
			}
			if(that.r_book_type){
				r_data.book_type = that.r_book_type
			}
			
			
			// 超级管理、投放管理才有投手
			// if(that.role_control.includes(1) || that.role_control.includes(3)){
			// 	r_data.op_id = that.r_op_id
			// }
			// 有op_id字段，则表示有投手搜索条件
			if(Object.keys(that.filterData.op_id).length > 0){
				r_data.op_id = that.r_op_id
			}
			
			// r_data.start_time = that.startTime.replace(/-/g, '')
			// r_data.endTime = that.endTime.replace(/-/g, '')
			
			// let request_string = "start_time=" + that.startTime.replace(/-/g, '') + '&end_time=' + that.endTime.replace(/-/g, '')
			// console.log("request_string",this.request_string)
			// console.log("搜索条件：投手id",this.r_op_id) // 搜索条件：投手id
			// console.log("搜索条件：书籍",this.r_put_book) // 搜索条件：书籍
			// console.log("搜索条件：书籍类型id",this.r_book_type) // 搜索条件：书籍类型，1=男频，2=女频，0是全部，全部的情况好像可以不发送
			// console.log("搜索条件：媒体平台id",this.r_platform_id) // 媒体平台
			// console.log("搜索条件：媒体版位id",this.r_media_id) // 媒体版位
			// console.log("搜索条件：书城",this.r_channel_id) //  书城
			// console.log("搜索条件：公众号",this.r_gzh_id) // 公众号
			
			
			// console.log("搜索条件：数据项",this.tableThLabel) // 数据项
			// console.log("搜索条件：数据项",this.collectHeadLabel) // 汇总条件
			let r_group_by = '',r_order_by = ''
			
			that.collectHeadLabel.forEach((res,index)=>{
				if(res.checked_status){
					r_group_by = r_group_by + res.type + ","
				}
			})
			
			if(class_ === 'desc'){
				r_data.order_by = type_ + " desc" 
			}
			else if(class_ === 'asc'){
				r_data.order_by = type_ + " asc" 
			}
			else {
				that.collectHeadLabel.forEach((res,index)=>{
					if(res.checked_status){
						r_order_by = r_order_by + res.type + " desc,"
					}
				})
				r_data.order_by = r_order_by.slice(0,-1)
			}
			
			r_data.group_by = r_group_by.slice(0,-1)
			
			
			// 表格的 投放日期 排序，在投放日期为 周 和 月 时，要进行特殊处理
			if(type_ == 'date_key' && that.r_date_type == 'month' && class_ == 'desc'){
				r_data.order_by = "YEAR(put_data.date_key) DESC,MONTH(put_data.date_key) DESC"
				// r_data.group_by = ""
			}
			else if(type_ == 'date_key' && that.r_date_type == 'month' && class_ == 'asc'){
				r_data.order_by = "YEAR(put_data.date_key) ASC,MONTH(put_data.date_key) ASC"
				// r_data.group_by = ""
			}
			else if(that.r_date_type == 'month' && !type_){ // 默认状态下不排序，也是这个值
				r_data.order_by = "YEAR(put_data.date_key) DESC,MONTH(put_data.date_key) DESC"
			}
			// 周 维度的先注释
			// if(type_ == 'date_key' && that.r_date_type == 'week' && class_ == 'desc'){
			// 	r_data.order_by = "YEARWEEK(put_data.date_key,1) desc"
			// }
			// else if(type_ == 'date_key' && that.r_date_type == 'week' && class_ == 'asc'){
			// 	r_data.order_by = "YEARWEEK(put_data.date_key,1) asc"
			// }
			
			// console.log("投放日期",this.filterData.time_type.list)
			if(this.collectHeadLabel[0].checked_status){ // 表示选中
				r_data.date_type = that.r_date_type
			}
			else { // 未选中默认传day
				r_data.date_type = "day"
			}
			
			let r_field = ""
			// 2023.4.4新加内容
			this.collectHeadLabel.forEach((res,index)=>{
				if(res.checked_status){
					if(res.label == "公众号/推广链接"){
						r_field = r_field + res.type + "," + "channel_id,"
					}
					else {
						r_field = r_field + res.type + ","
					}
					
				}
			})
			
			this.tableThLabel.forEach((res,index)=>{
				if(res.checked_status){
					if(res.label == "首日ROI"){
						r_field = r_field + res.type + "," + "today_left_money,"
					}
					else if (['recent_left_money_next_1', 'recent_left_money_roi_next_1'].includes(res.type)) {
						if (!r_field.includes('next_money')) {
							r_field = r_field + 'next_money' + ","
						}
					}
					else {
						r_field = r_field + res.type + ","
					}
					
				}
			})
			r_data.field = r_field.slice(0,-1)
			
			// console.log("r_data",r_data)
			
			// console.log("that.collectHeadLabel",that.collectHeadLabel)
			
			
			that.rableTitle.forEach((res_z,index_z)=>{
				// 控制哪些表头不用显示
				that.tableThLabel.forEach((res,index)=>{
					if(res_z.type === res.type){
						res_z.show_control = res.checked_status
					} 
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_1'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_2'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_3'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_4'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_5'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_6'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_roi' && res_z.type === 'recent_left_money_roi_before_7'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_1'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_2'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_3'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_4'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_5'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_6'){
						res_z.show_control = res.checked_status
					}
					else if(res.type === 'seven_left_money' && res_z.type === 'recent_left_money_before_7'){
						res_z.show_control = res.checked_status
					}
				})
				
				// 固定列的处理
				that.collectHeadLabel.forEach((res_c,index_c) =>{
					if(res_c.label === '投放日期' && res_z.type === 'date_key'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '渠道内容' && res_z.type === 'content_type'){
						res_z.show_control = res_c.checked_status
						// that.search_control_a = res_c.checked_status
					}
					else if(res_c.label === '渠道' && res_z.type === 'channel_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '公众号/推广链接' && res_z.type === 'gzh_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投放作品' && res_z.type === 'book_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '作品频道' && res_z.type === 'book_type'){
						res_z.show_control = res_c.checked_status
						// that.search_control_b = res_c.checked_status
					}
					else if(res_c.label === '媒体平台' && res_z.type === 'platform_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '媒体版位' && res_z.type === 'media_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投手' && res_z.type === 'op_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '投放小组' && res_z.type === 'group_name'){
						res_z.show_control = res_c.checked_status
					}
					else if(res_c.label === '小程序' && res_z.type === 'applets_name'){
						res_z.show_control = res_c.checked_status
					}
				})
			})
			
			// 三个渠道的ID合为一个
			let qd_id = []
			qd_id = qd_id.concat(that.r_channel_id)
			if(that.r_qk_channel_id){ // 因为这个快应用下拉是单选，当清除单选内容时会返回undefined或null
				qd_id = qd_id.concat(that.r_qk_channel_id)
			}
			qd_id = qd_id.concat(that.r_vd_qd)
			qd_id = qd_id.concat(that.r_xs_xcx_channel)
			r_data.channel_id = qd_id
			
			// 三个渠道下的推广链接合为一个
			let put_id = []
			put_id = put_id.concat(that.r_gzh_id)
			put_id = put_id.concat(that.r_qk_url)
			put_id = put_id.concat(that.r_vd_channel)
			put_id = put_id.concat(that.r_xs_xcx_link)
			r_data.gzh_id = put_id
			
			// console.log("that.rableTitle",that.rableTitle)
			if(button_type != '导出'){
				putDataGetChargeSumNew(r_data).then(res=>{
					// 表格宽度自适应
					that.tableWidthInfo()
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.table_total = res.data.data.total
						if(res.data.data.data.length === 0 && res.data.data.sum.length === 0){
							that.tableTotalData = []
							that.tableShowData = []
							that.search_button_loading = false
						}
						else {
							let req_data = JSON.parse(JSON.stringify(res.data.data))
							
							// 总计那一行的处理
							// 后端返回的sum字段里没有这些键名，需要自己加
							let z_data = req_data.sum
							that.tableTotalData = req_data.sum
							
							// 表格内容处理开始
							let show_data = req_data.data
							
							that.tableShowData = req_data.data
							
						}
						
						// 根据展示内容的不同，要对内容宽度进行处理
						// let nnn = 30 // 边距
						// that.rableTitle.forEach((res,index)=>{
						// 	if(res.show_control){
						// 		nnn += res.width
						// 	}
						// })
						// that.table_scroll_width = nnn 
						// console.log("nnn",nnn)
						
						that.date_type_control = that.r_date_type
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
				.catch(err=>{
					that.$message.error('搜索请求错误，可能是网络不佳');
					that.search_button_loading = false
				})
			}
			else if(button_type == '导出'){
				r_data.report = 1
				delete r_data.page
				delete r_data.limit
				putDataExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
			
			}
		},
		// 导出按钮
		exportButton(e){
			let that = this
			that.searchButton('','','导出')
			
		},
		// 表格项宽度自适应
		tableWidthInfo(){
			let that = this
			// console.log("tableWidthInfo",that.rableTitle);
			let body_width = document.body.clientWidth - 40
			let table_width = 0 // 表格内容的宽度
			let null_width = 0 // 空提示的宽度
			let nn = 30 // 这个20是通过fixed定位在页面最右部盒子的宽度，用来遮挡表格最后部，使表格最右边的内容距离浏览器边框有段距离
			that.rableTitle.forEach((res,index)=>{
				// 有的表格里带show_control字段，这里要做区分
				// if(res.hasOwnProperty('show_control')){
					if(res.show_control){
						nn = nn + res.s_width
					}
				// }
				// else {
				// 	nn = nn + res.width
				// }
				
			})
			// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
			if(nn < body_width && body_width - nn > 30){ // 当表格内容不足以沾满一屏时，要适配成一屏
				console.log("适配")
				that.rableTitle.forEach(res=>{ // 针对表格每一项的宽度进行适配
					res.width = Math.round((res.s_width/nn)*body_width) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
				})
				table_width = body_width
			}
			else { // 表格宽度大于等于屏幕可视宽度
				console.log("不适配")
				that.rableTitle.forEach(res=>{ 
					res.width = res.s_width // 不适配的话，每一项表格宽度用回原始宽度
				})
				table_width = nn
			}
				
			// 表格空提示宽度，以及分页组件的宽度
			if(table_width >= body_width){ 
				null_width = body_width
			}
			else { 
				null_width = table_width
			}
			that.table_scroll_width = table_width
			that.table_null_width = null_width
		},
		// 点击表格的表头排序
		tableThClick(index,status,type){
			let that = this
			// console.log("点击表格的表头排序",index)
			// console.log("点击表格的表头排序",status)
			console.log("点击表格的type",type)
			let ttt = type
			if(type == "recent_left_money"){
				ttt = "recent_left_money_roi"
			}
			
			if(status === 1){ // desc排序，箭头向下
				console.log('desc排序，箭头向下')
				that.px_order = ttt
				that.px_sort = 'desc'
				that.searchButton('desc',ttt)
			}
			else if(status === 2){ // asc排序，箭头向上
				that.px_order = ttt
				that.px_sort = 'asc'
				console.log('asc排序，箭头向上')
				that.searchButton('asc',ttt)
			}
			else { // 默认
				that.px_order = null
				that.px_sort = null
				that.searchButton()
			}
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('','','分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
	},
	
}
</script>

<style scoped>
.page-big-box {
	background-color: rgb(240, 242, 245);
	margin: -20px -30px -30px -30px;
	padding: 20px 20px 20px 20px;
	min-height: calc(100vh - 85px);
}

.class-title {
	font-size: 16px;
	margin-bottom: 10px;
	text-align: left;
}

.loading-box {
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	z-index: 111;
	text-align: center;
	line-height: 100vh;
}

.col-left-label {
	text-align: right;
	padding-right: 15px;
}
.padding-right-15 {
	padding-right: 15px;
}
.margin-bottom-15 {
	margin-bottom: 15px;
}
</style>